
import React from 'react';
import { PopupContent } from '@/types/popup-system';

interface MotivationalContentProps {
  content: PopupContent;
  onAction: (action: string) => void;
}

export const MotivationalContent = ({ content, onAction }: MotivationalContentProps) => {
  return (
    <div className="p-4">
      <div 
        className="mb-4 text-sm leading-relaxed whitespace-pre-wrap"
        style={{ color: 'var(--popup-text)' }}
      >
        {content.message}
      </div>
      
      {/* Action Buttons */}
      <div className="flex justify-end space-x-2">
        {content.actionButtons?.map((button, index) => (
          <button
            key={index}
            onClick={() => onAction(button.action)}
            className="px-4 py-2 text-sm font-semibold border transition-all duration-200 hover:brightness-110"
            style={{
              backgroundColor: 'var(--popup-button-bg)',
              color: 'var(--popup-text)',
              borderColor: 'var(--popup-border)'
            }}
          >
            {button.text}
          </button>
        ))}
      </div>
    </div>
  );
};
